import { storableError } from '../../util/errors';
import { setCurrentUser } from '../../ducks/user.duck';
import { denormalisedResponseEntities } from '../../util/data';
import { notifyMarketingOptIn } from '../../util/api';

// ================ Action types ================ //

export const UPDATE_REQUEST = 'app/MarketingPreferencesPage/UPDATE_REQUEST';
export const UPDATE_SUCCESS = 'app/MarketingPreferencesPage/UPDATE_SUCCESS';
export const UPDATE_ERROR = 'app/MarketingPreferencesPage/UPDATE_ERROR';

// ================ Reducer ================ //

const initialState = {
  updateInProgress: false,
  updateError: null,
};

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case UPDATE_REQUEST:
      return { ...state, updateInProgress: true, updateError: null };
    case UPDATE_SUCCESS:
      return { ...state, updateInProgress: false };
    case UPDATE_ERROR:
      return { ...state, updateInProgress: false, updateError: payload };
    default:
      return state;
  }
}

// ================ Thunks ================ //

export const updateMarketingOptIn = optIn => (dispatch, getState, sdk) => {
  dispatch({ type: UPDATE_REQUEST });

  // Treat legacy `undefined` as `true` (implicit opt-in pre-feature) so
  // saving the form without changes never fires a spurious notify.
  const prevUser = getState().user.currentUser;
  const prevOptIn = prevUser?.attributes?.profile?.privateData?.marketingOptIn ?? true;
  const nextOptIn = !!optIn;

  return sdk.currentUser
    .updateProfile({ privateData: { marketingOptIn: nextOptIn } }, { expand: true })
    .then(response => {
      const entities = denormalisedResponseEntities(response);
      if (entities.length !== 1) {
        throw new Error('Expected a resource in the sdk.currentUser.updateProfile response');
      }
      const currentUser = entities[0];

      dispatch(setCurrentUser(currentUser));
      dispatch({ type: UPDATE_SUCCESS });

      if (prevOptIn !== nextOptIn) {
        notifyMarketingOptIn({ eventType: 'account-update' });
      }
    })
    .catch(e => dispatch({ type: UPDATE_ERROR, payload: storableError(e) }));
};
